import { useCallback } from "react";
import { RouterProvider } from "react-router-dom";
import { AuthTrackingProvider } from "@shared/features/tracking/AuthTrackingProvider";
import useSyncFirebaseToken from "@shared/services/api/useSyncFirebaseToken";
import {
  TOKEN_EXPIRED_SET,
  usePlatform,
  usePlatformDispatch,
} from ".//PlatformContext";
import { useFetchSupportArticles } from "./features/support/hooks/useFetchSupportArticles";
import { useFetchPlatformClosedStatus } from "./hooks/useFetchPlatformClosedStatus";
import { PlatformEventListeners } from "./PlatformEventListeners";
import { router } from "./router";
import { ChatProvider } from "./features/chat/ChatContext";

export function PlatformApp() {
  const dispatch = usePlatformDispatch();

  const setTokenExpiredStatus = useCallback(
    (isTokenExpired: boolean) => {
      dispatch({
        type: TOKEN_EXPIRED_SET,
        payload: isTokenExpired,
      });
    },
    [dispatch]
  );

  useSyncFirebaseToken({ setTokenExpiredStatus });

  const { user, organization, isTokenExpired } = usePlatform();

  useFetchSupportArticles();
  useFetchPlatformClosedStatus();

  return (
    <ChatProvider>
      <AuthTrackingProvider
        debug={{ enabled: false }}
        user={user || ({} as any)}
        organization={organization || ({} as any)}
        isTokenExpired={isTokenExpired ?? false}
      >
        <PlatformEventListeners />
        <RouterProvider router={router} />
      </AuthTrackingProvider>
    </ChatProvider>
  );
}
